import { href } from "../App/href";
import { ConfirmDialog } from "../ConfirmDialog/ConfirmDialog";
import { database } from "../database/database";
import { useWarbandContext } from "./useWarbandContext";

export function DuplicateWarband() {
  const warband = useWarbandContext();

  return (
    <ConfirmDialog
      heading="Duplicate warband?"
      description={`A new warband matching ${warband.name} will be created.`}
      submitLabel="Duplicate"
      onSubmit={async () => {
        const next = warband.duplicate();
        const result = await database.warbands.putOne(next.data);

        return result.mapSuccess((warbandId) => ({
          navigateTo: href("~/builder/w/:warbandId", { path: { warbandId } }),
        }));
      }}
    />
  );
}

export function SaveSharedWarband() {
  const warband = useWarbandContext();

  return (
    <ConfirmDialog
      heading="Save Warband?"
      description={`A copy of this warband (${warband.name}) will be saved to your list.`}
      submitLabel="Save warband"
      onSubmit={async () => {
        const next = warband.duplicate();
        const result = await database.warbands.putOne(next.data);

        return result.mapSuccess((warbandId) => ({
          navigateTo: href("~/builder/w/:warbandId", { path: { warbandId } }),
        }));
      }}
    />
  );
}
